import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-683421e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-shipping" }
const _hoisted_2 = { class: "store flex-ter" }
const _hoisted_3 = {
  key: 0,
  class: "ml_20"
}
const _hoisted_4 = { class: "address flex-bwn" }
const _hoisted_5 = { class: "address-info" }
const _hoisted_6 = { class: "rel" }
const _hoisted_7 = {
  key: 0,
  class: "tip abs",
  style: {"left":"9px","bottom":"-32px","width":"300px"}
}
const _hoisted_8 = {
  key: 0,
  class: "tip",
  style: {"margin-left":"10px"}
}
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = {
  key: 1,
  class: "flex"
}
const _hoisted_11 = { class: "create-form" }
const _hoisted_12 = {
  key: 0,
  class: "flex",
  style: {"align-items":"flex-start","margin-bottom":"30px"}
}
const _hoisted_13 = {
  class: "flex",
  style: {"align-items":"flex-start"}
}
const _hoisted_14 = { style: {"margin-top":"30px"} }
const _hoisted_15 = { class: "inShipConfig flex" }
const _hoisted_16 = { style: {"width":"280px"} }
const _hoisted_17 = {
  key: 0,
  class: "compute-price"
}
const _hoisted_18 = { class: "flex-ter warehouse-content" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/help_icon.png",
  alt: ""
}, null, -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "setting-form" }
const _hoisted_23 = {
  class: "flex-bwn-ter",
  style: {"margin-top":"8px"}
}
const _hoisted_24 = { class: "setting" }
const _hoisted_25 = { style: {"display":"flex","align-items":"center","color":"var(--el-text-color-regular)","font-size":"15px"} }
const _hoisted_26 = { style: {"margin-right":"16px"} }
const _hoisted_27 = { style: {"font-weight":"700"} }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  style: {"padding-top":"30px"}
}
const _hoisted_32 = {
  key: 0,
  class: "error-result"
}
const _hoisted_33 = { class: "error-icon flex-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/fail_icon.png",
  alt: ""
}, null, -1))
const _hoisted_35 = { class: "error-res" }
const _hoisted_36 = {
  key: 1,
  class: "error-result success"
}
const _hoisted_37 = { class: "error-icon flex-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/success_icon2.png",
  alt: ""
}, null, -1))
const _hoisted_39 = { style: {"padding":"20px"} }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "create-replenishment-confirm-header" }
const _hoisted_42 = { class: "create-replenishment-confirm-content" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "btn" }

import { t } from '@/plugins/i18n'
import { toRaw, ref, watch, onMounted, onUnmounted, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue'
import type { FormInstance } from 'element-plus'
import BindAmazonSkuModal from '@/views/product/Stock/components/BindAmazonSkuModal.vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import DeliveryForm from '../components/DeliveryForm.vue'
import AddProduct from '../components/AddProduct.vue'
import AddressConfig from '../components/AddressConfig.vue'
import BindAmazon from '../components/BindAmazon.vue'
import OverseaProductSku from '../components/OverseaProductSku.vue'
import TariffConfig from '../components/TariffConfig.vue'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { createReplenishPlan, getCustomerProductSkuListApi } from '@/apis/inShipping'
import { pageMyInventoryList, getPrepCategoryListApi } from '@/apis/stock'
import { getCustomerShop } from '@/apis/order'
import { useRtfix, isD2C, expressCostPdf, useSite, isJA, getCustomerNationCode2, useSite2Code, getWarehouseCode, isMultiStore, isChoiceShop } from '@/store'
import { productColumns, productTableConfig2, errorMap } from './data'
import { cloneDeep } from 'lodash'
import useForm from './useForm'
import useAddress, { getAreaTxt, getCityTxt } from './useAddress'
import useProduct from './useProduct'
import AmazonWarningDialog from './components/AmazonWarningDialog.vue'
import AmazonTip from '@/views/authorized/SyncProduct/AmazonTip.vue'
import { useStore } from 'vuex'
import { getConfigApi, setConfigApi } from '@/apis/user'
import { COUNTRY } from '@/global'
import { request } from '@/config/request/interceptors'
import { ErrorSku } from '@/service/apis'
import CheckAmazonGoodsModal from './components/CheckAmazonGoodsModal.vue'
import { labelMap } from '@/views/authorized/SyncProduct/data'
import UploadBtn from '../components/UploadGoods/btn.vue'
interface SortParmas {
  column: any
  order: 'ascending' | 'descending' | null
  prop: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()

const isCrossMall = computed(() => store.getters.isCrossMall)
// 仓库类型 中国CN  韩国KR
const wareType = ref<string>(route.params?.wareType as string ?? 'CN')
const site = useSite()
const warehouseCode = ref('')
const estimateIntShip = ref(null)

const {
  form,
  rules,
  formRef,
  weight,
  // estimateIntShip,
  getEstimateIntShipInfo,
  changePrice,
  inputPrice,
  additionalLabelDict,
  intShipTypeOption,
  intShipType,
  templateOption,
  templatePreview
} = useForm(wareType.value)
const amazonFnskuSort = reactive({
  sortedTableData: [] as any[],
  orderType: null as SortParmas['order']
})
const list = computed(() => {
  const list1 = [...form.replenishPlanItemList]
  if (!amazonFnskuSort.orderType) {
    return list1
  }
  if (amazonFnskuSort.orderType === 'ascending') {
    return [...form.replenishPlanItemList].sort((a: any, b: any) => {
      // return a.amazonFnsku - b.amazonFnsku
      return (a.amazonFnsku ?? '').localeCompare(b.amazonFnsku ?? '')
    })
  }
  return [...form.replenishPlanItemList].sort((a: any, b: any) => {
    return (b.amazonFnsku ?? '').localeCompare(a.amazonFnsku ?? '')
  })
})

/**
 * 总发货量
 */
const totalShipments = computed(() => {
  return form.replenishPlanItemList.reduce((pre: any, cur: any) => {
    console.log(cur.deliveryNums, 111)
    return pre + Number(cur.deliveryNums ?? 0)
  }, 0)
})

const handleSortChange = (params: SortParmas) => {
  if (params.prop === 'amazonFnsku') {
    amazonFnskuSort.orderType = params.order
  }
  if (params.prop === null && params.order === null) {
    amazonFnskuSort.orderType = null
  }
}

const {
  showClearanceAddress,
  clearanceAddressConfig,
  addClearance,
  setDefaultClearanceAddress,
  openClearanceAddressVisible,
  provinces,
  selectClearanceAddress,
  selectClearanceAddressFn,
  refreshClearanceList
} = useAddress(form, route.params?.wareType as string ?? '')

const {
  STableRef,
  getProductSkuList,
  addProductVisible,
  openAddProductVisible,
  handleSelection,
  delMoreRow,
  delRow
} = useProduct(form, formRef)

if (route.query?.shopProductSku) {
  const shopProductSkuList = route.query.shopProductSku.toString().split(',')
  pageMyInventoryList(shopProductSkuList).then((res: any) => {
    form.replenishPlanItemList = res.data.map((e: any) => ({ ...e, useable: e.availableQuantity, deliveryNums: e.availableQuantity })).filter((e: any) => e.useable)
  })
}

const rowItem = ref()
const bindAmazonVisible = ref(false)
const openBindAmazon = (row: any) => {
  rowItem.value = row
  bindAmazonVisible.value = true
}

const templateVisible = ref(false)
const openTemplateVisible = () => {
  if (!templatePreview.value) return ElMessage.warning(t('请选择打印模板'))
  templateVisible.value = true
}

const batchDeleteRow = () => {
  delMoreRow()
  estimateIntShip.value = null
}

const setAmazonInfo = (val: any, row: any) => {
  form.replenishPlanItemList = form.replenishPlanItemList.map((e: any) => {
    return (e.productSku === row.productSku ? {
      ...e,
      ...val,
      amazonProductTitle: val.productName,
      productSku: e.productSku,
      amazonBindStatus: 2
    } : e)
  })
}

const router = useRouter()
const submitLoading = ref(false)
const confirmVisible = ref(false)
const tariffConfig = ref()
let submitForm: any = {}
const submit = async (formEl: FormInstance | undefined) => {
  // beforeCheckGoods()
  let taxData = {}
  const hasTaxConfig = await tariffConfig.value.taxValid()
  if (!hasTaxConfig) {
    return
  }
  taxData = await tariffConfig.value.getTaxData()

  if (!selectClearanceAddress.value) {
    ElMessage.warning(t('请选择清关地址'))
    return
  }
  if (!formEl) return
  if (!form.replenishPlanItemList.length) return ElMessage.warning(t('请选择商品'))
  for (const v of form.replenishPlanItemList) {
    if (v.amazonBindStatus !== 2) {
      return ElMessage.warning(t('请绑定 Amazon sku'))
    }
  }
  if (!selectClearanceAddress.value.email) {
    ElMessage.warning(t('请填写邮箱'))
    return
  }
  formEl.validate((valid) => {
    if (valid) {
      const {
        additionalList,
        declarationAddress,
        distribution,
        forwarder,
        intForwarderConfigId,
        intShipConfigId,
        labelTemplateId,
        replenishPlanItemList,
        shippingType,
        title,
        allIncludeFlag,
        transportType
      } = toRaw(form)
      submitForm = {
        distribution,
        forwarder,
        intForwarderConfigId,
        intShipConfigId,
        labelTemplateId,
        shippingType,
        title,
        allIncludeFlag,
        ...taxData
      }
      if (allIncludeFlag === 1) {
        submitForm.shippingType = '0'
        submitForm.forwarder = '0'
        submitForm.distribution = '0'
        submitForm.intForwarderConfigId = 0
        submitForm.transportType = transportType
      }
      submitForm.declarationAddress = {
        address: declarationAddress.addressEn,
        province: declarationAddress.areaEn,
        city: declarationAddress.cityEn,
        clubCode: declarationAddress.companyCode,
        companyName: declarationAddress.companyNameEn,
        mobile: declarationAddress.phone,
        name: declarationAddress.receiveNameEn,
        postalCode: declarationAddress.postalCode,
        email: declarationAddress.email,
        clearanceCode: declarationAddress.clearanceCode,
        clearanceType: declarationAddress.clearanceType
      }
      submitForm.originalDeclarationAddress = {
        address: declarationAddress.address,
        province: declarationAddress.area,
        city: declarationAddress.city,
        clubCode: declarationAddress.companyCode,
        companyName: declarationAddress.companyName,
        mobile: declarationAddress.phone,
        name: declarationAddress.receiveName,
        postalCode: declarationAddress.postalCode,
        email: declarationAddress.email,
        clearanceCode: declarationAddress.clearanceCode,
        clearanceType: declarationAddress.clearanceType
      }
      submitForm.additionalList = additionalList.map((e: any) => ({
        additionConfigId: e.additionConfigId,
        additionCode: e.additionCode,
        additionId: e.additionId,
        ingredientsSku: e.ingredientsSku
      }))

      submitForm.replenishPlanItemList = replenishPlanItemList.map((e: { deliveryNums: any; productSku: any; shopProductSku: any }) => {
        submitForm.deliveryNums += Number(e.deliveryNums)
        return {
          deliveryNums: Number(e.deliveryNums),
          shopProductSku: e.shopProductSku
        }
      })
      if (isAmazon.value) {
        confirmVisible.value = true
      } else {
        // 校验通过之后校验amazon商品信息
        createReplenishment()
        // beforeCheckGoods()
      }
    } else {
      return false
    }
  })
}

// 创建补货计划查询
const getTaskResultLoading = ref(false)

const createReplenishment = async () => {
  confirmVisible.value = false
  submitLoading.value = true
  const res: any = await request.apis.replenishPlan.createPlan({
    ...submitForm,
    warehouseCode: getWarehouseCode(wareType.value === COUNTRY.KR)
  }).catch((error) => {
    console.log('error', error)
    getTaskResultLoading.value = false
    submitLoading.value = false
    return { success: false }
  })
  console.log('asdad', res)
  if (res.success) {
    submitLoading.value = false
    if (res?.data?.errorList?.length) {
      amazonWarningVisible.value = true
      amazonErrorList.value = res?.data?.errorList ?? []
      return
    }
    const successFn = () => {
      // ElMessage.success(t('创建成功'))
      // router.push(useRtfix('ReplenishmentList'))
      const configName = '国际发货-关税收取方式的默认选择'
      const configCode = {
        configName,
        sendType: 'fba'
      }
      const params = {
        configCode: JSON.stringify(configCode),
        configValue: String(submitForm.tariffType),
        configName: configName
      }
      setConfigApi(params)
      checkAmazonGoodsModalRef.value.createSuccess = true
    }
    let timer = null

    const interverFn = async () => {
      getTaskResultLoading.value = true
      const res1: any = await request.apis.getTaskResult.getTaskResult({ taskId: res.data?.taskId ?? '' })
      if (res1.success) {
        if (res1.data?.status === 'in_process') {
          timer = setTimeout(interverFn, 3000)
        } else if (res1.data?.status === 'fail') {
          checkAmazonGoodsModalRef.value.createVisible = false
          // 异常报错重新弹窗走校验
          if (res1.data?.errorList?.length) {
            // 修改tableerrocode
            form.replenishPlanItemList.forEach((item: any) => {
              const findItem = res1.data?.errorList.find(v => item.amazonMsku === v.msku)
              if (findItem) {
                item.errorCode = findItem.errorType
              }
            })
            checkAmazonGoodsModalRef.value.open(res1.data?.errorList)
          } else {
            ElMessage.error(res1.data.errorMsg)
          }
          getTaskResultLoading.value = false
        } else {
          getTaskResultLoading.value = false
          successFn()
        }
      } else {
        // 系统异常报错
        checkAmazonGoodsModalRef.value.createVisible = false
      }
    }
    if (res.data?.taskId) {
      interverFn()
    } else {
      successFn()
    }
    return true
  } else {
    submitLoading.value = false
    ElMessage.error(res.msg)
    return false
  }
}
// 店铺仓库
const wareName = ref('')
const isAmazon = ref()
getCustomerShop().then((res: any) => {
  if (res.success) {
    const warehouseList = res.data?.warehouseList ?? []
    // 表结构变了，换种形式获取仓库名称
    wareName.value = warehouseList.find((item: { warehouseCountry: string }) => item.warehouseCountry === wareType.value)?.warehouseNameTranslate
    isAmazon.value = !!(res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus)
  }
})
const amazonWarningVisible = ref(false)
const amazonErrorList = ref<ErrorSku[]>([])

const getData = () => {
  return {
    skuList: form.replenishPlanItemList.map((v: any) => {
      return {
        num: v.deliveryNums,
        productType: v.productType,
        productSku: v.productSku
      }
    }),
    countryCode: getCustomerNationCode2(),
    systemSource: isD2C() ? 1 : 2
  }
}
watch(() => form.replenishPlanItemList, () => {
  estimateIntShip.value = null
})
const changeExpress = (id: any, item: any) => {
  estimateIntShip.value = item.priceCny
}
const jumpExpressPrice = () => {
  const { declarationAddress, replenishPlanItemList } = toRaw(form)
  if (!replenishPlanItemList?.length) {
    ElMessage.warning(t('请选择商品'))
    return
  }
  // if (!declarationAddress.nationCode && declarationAddress.shopClearanceAddressId) {
  //   ElMessage.warning(t('当前清关地址不可用'))
  //   return
  // }
  // if (!declarationAddress.shopClearanceAddressId) {
  //   ElMessage.warning(t('请选择清关地址'))
  //   return
  // }
  const params = {
    membershipTemplateId: store.getters.user.membership?.membershipTemplateId,
    productParam: replenishPlanItemList.map((item: any) => {
      return {
        additionList: [],
        num: item.deliveryNums,
        productInfo: {
          productSellPrice: item.unitPrice,
          productSkuImg: item.productSkuImg,
          productTitle: item.productTitle
        },
        productSellPrice: item.unitPrice,
        productSku: item.productSku
      }
    }),
    shipParam: {
      countryCode: useSite2Code()
    }
  }
  window.localStorage.setItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`, JSON.stringify(params))
  window.open('/oem/utility/InterLogistics?from=inshipping')
}
const isHaveChoiceStock = ref(false)
onMounted(() => {
  window.addEventListener('storage', shipParamChangeListner)
  // TODO 根据上一次的选择，默人初始化这次的选择
  const configName = '国际发货-关税收取方式的默认选择'
  const configCode = {
    configName,
    sendType: 'fba'
  }
  const params = {
    configCode: JSON.stringify(configCode),
    level: 3
  }
  getConfigApi(params).then((res) => {
    if (res.code !== '0' || [null, undefined].includes(res?.data?.configValue)) {
      tariffConfig.value.setInitTariffType(1)
      return
    }
    tariffConfig.value.setInitTariffType(Number(res.data.configValue))
  })

  getCustomerProductSkuListApi({
    goodsCountry: 'CN'
  }).then((res) => {
    isHaveChoiceStock.value = res.data?.some(v => v.allIncludeUseable && v.allIncludeUseable > 0)
  })
})

onUnmounted(() => {
  window.removeEventListener('storage', shipParamChangeListner)
})

const shipParamChangeListner = (event: any) => {
  if (event.key === `Calculator_${isD2C() ? 1 : 2}_inshipping`) {
    const { shipParam } = JSON.parse(window.localStorage.getItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`) ?? '{}')
    console.log('接收：', shipParam)
    if (shipParam?.intShipConfigId) {
      intShipType.value = shipParam?.intShipConfigId
      estimateIntShip.value = shipParam?.price
    }
  }
}

const checkAmazonGoodsModalRef = ref()

const beforeCheckGoods = () => {
  confirmVisible.value = false
  checkAmazonGoodsModalRef.value.open()
}
// 更新amazon商品状态errorCode

const updateGoods = (record: any) => {
  form.replenishPlanItemList.forEach((item: any) => {
    if (item.amazonMsku === record.amazonMsku) {
      item.errorCode = record.errorCode
      item.labelOwnerConstraint = record.labelOwnerConstraint
      item.prepCategory = record.prepCategory
      item.prepOwnerConstraint = record.prepOwnerConstraint
    }
  })
  // const index = form.replenishPlanItemList.findIndex(v => v.productSku === item.productSku)
  // form.replenishPlanItemList[index].errorCode = item.errorCode
  // form.replenishPlanItemList[index].labelOwnerConstraint = item.labelOwnerConstraint
  // form.replenishPlanItemList[index].prepCategory = item.prepCategory
  // form.replenishPlanItemList[index].prepOwnerConstraint = item.prepOwnerConstraint
}

const delGoods = (item: { productSku: string, shopProductSku: string }) => {
  form.replenishPlanItemList = form.replenishPlanItemList.filter((v) => v.productSku !== item.productSku)
  // 
  submitForm.replenishPlanItemList = submitForm.replenishPlanItemList.filter((v) => v.shopProductSku !== item.shopProductSku)
}

const prepCategoryList: any = ref([])
const getCategoryList = () => {
  getPrepCategoryListApi().then((res) => {
    prepCategoryList.value = res.data ?? []
  })
}
getCategoryList()
const changeAllIncludeFlag = (e) => {
  form.replenishPlanItemList = []
  intShipType.value = form.allIncludeFlag === 1 ? 0 : null
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        _isRef(formRef) && (formRef.value = _value)
      },
      inline: true,
      model: _unref(form),
      rules: _unref(rules)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('店铺名称')) + "：" + _toDisplayString(_unref(form).customerShopName ?? ''), 1),
          (_unref(isMultiStore)())
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('仓库')) + " ： " + _toDisplayString(wareType.value === 'KR' ? _unref(t)('韩国仓') : _unref(t)('中国仓')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_unref(t)('清关地址')) + "： ", 1),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: _unref(openClearanceAddressVisible)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(showClearanceAddress) ? _unref(t)('选择清关地址') : _unref(t)('添加清关地址')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_unref(selectClearanceAddress))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('需要填写清关地址')), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(selectClearanceAddress) && !_unref(selectClearanceAddress)?.email)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)("请填写邮箱")), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(showClearanceAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.receiveName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.companyName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.companyCode), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.countryCode) + _toDisplayString(_unref(selectClearanceAddress).phone), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(showClearanceAddress))
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.countryName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(getAreaTxt)(_unref(selectClearanceAddress), _unref(provinces)) || _unref(selectClearanceAddress)?.provinceName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(getCityTxt)(_unref(selectClearanceAddress), _unref(provinces)) || _unref(selectClearanceAddress)?.cityName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.address), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(selectClearanceAddress)?.postalCode), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (isHaveChoiceStock.value && wareType.value !== 'KR')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('发货类型'),
                  prop: "deliveryTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _unref(form).allIncludeFlag,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).allIncludeFlag) = $event)),
                      onChange: changeAllIncludeFlag
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('一价全包商品发货')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('普通商品发货')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('补货批次标题'),
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).title) = $event)),
                  maxlength: 100
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('打印标签模板'),
              prop: "labelTemplateId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(form).labelTemplateId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).labelTemplateId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateOption), (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: v.id,
                        value: v.id,
                        label: v.templateName,
                        onClick: ($event: any) => (templatePreview.value = v.templateHtml)
                      }, null, 8, ["value", "label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"20px"},
                  type: "text",
                  onClick: openTemplateVisible
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('预览')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('发货附加项')
            }, {
              default: _withCtx(() => [
                _createVNode(DeliveryForm, {
                  additionalList: _unref(form).additionalList,
                  "onUpdate:additionalList": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).additionalList) = $event)),
                  "is-oversea": true,
                  "is-mark": true,
                  dict: _unref(additionalLabelDict),
                  countryCode: wareType.value
                }, null, 8, ["additionalList", "dict", "countryCode"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_unref(form).allIncludeFlag === 0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(t)('物流方式'),
                  prop: "intShipConfigId",
                  style: {"word-break":"break-word"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(ExpressSelect, {
                            "default-express": _unref(intShipTypeOption),
                            id: _unref(intShipType),
                            "onUpdate:id": _cache[4] || (_cache[4] = ($event: any) => (_isRef(intShipType) ? (intShipType).value = $event : null)),
                            getData: getData,
                            feeTip: _unref(t)('请选择商品'),
                            onChange: changeExpress,
                            "country-code": wareType.value
                          }, null, 8, ["default-express", "id", "feeTip", "country-code"])
                        ]),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)('预估物流价')) + ":" + _toDisplayString(estimateIntShip.value ?? '-') + _toDisplayString(_unref(t)('元')), 1))
                          : _createCommentVNode("", true),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "compute",
                              onClick: jumpExpressPrice
                            }, _toDisplayString(_unref(t)('运费估算')) + ">", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)('店铺仓库所在地')) + ":" + _toDisplayString(wareName.value), 1),
                        (wareType.value !== _unref(COUNTRY).KR)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "light",
                              style: {"transform":"scale(.8)"},
                              target: "_blank",
                              href: _unref(expressCostPdf)()
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('国际料金表')) + " ", 1),
                              _hoisted_20
                            ], 8, _hoisted_19))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _unref(t)('物流方式'),
                  prop: "transportType",
                  style: {"word-break":"break-word"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _unref(form).transportType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).transportType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('海运')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('空运')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
          ]),
          (wareType.value !== _unref(COUNTRY).KR && _unref(form).allIncludeFlag === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "fee-tip",
                innerHTML: _unref(t)('国际料金表提示'),
                style: {"font-size":"12px","line-height":"17px","color":"#D44345","margin":"20px 0 0 10px"}
              }, null, 8, _hoisted_21))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TariffConfig, {
          ref: (_value, _refs) => {
            _refs['tariffConfig'] = _value
            tariffConfig.value = _value
          },
          allIncludeFlag: !!_unref(form).allIncludeFlag
        }, null, 8, ["allIncludeFlag"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(AmazonTip, {
              title: _unref(t)('根据Amazon的规定，建发货时需要建立好预处理分类、预处理方和贴标方，请及时去Amazon后台更新信息，并重新更新商品'),
              keyValue: "createReplenishmentTip"
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _unref(openAddProductVisible)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('添加商品')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: batchDeleteRow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('批量删除')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(UploadBtn, {
                  onSubmit: _unref(getProductSkuList),
                  sendType: 1,
                  isChoice: _unref(form).allIncludeFlag === 1
                }, null, 8, ["onSubmit", "isChoice"]),
                _createElementVNode("div", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_unref(t)('总发货数量')) + "： ", 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(totalShipments)), 1)
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: submitLoading.value,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (submit(_unref(formRef))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('创建')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ]),
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            _isRef(STableRef) && (STableRef.value = _value)
          },
          "table-data": _unref(list),
          columns: _unref(productColumns),
          showPagination: false,
          "table-config": _unref(productTableConfig2),
          onSelectionChange: _unref(handleSelection),
          onSortChange: handleSortChange
        }, {
          productMainImg: _withCtx(({ row }) => [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || ''
            }, null, 8, ["image"])
          ]),
          productSkuInfo: _withCtx(({ row }) => [
            _createElementVNode("p", null, _toDisplayString(row.productSku), 1),
            (row.productPropertiesName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_unref(t)('商品规格')) + " : ", 1),
                  (row.productType === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(row.productPropertiesName || ''), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(((row.productPropertiesName || '').split(';') || []).map((e) =>
                (e.replace(/[+-]?\d+:[+-]?\d+:/, '') || '').split(':')[1] ?? '').join(';')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          amazonFnsku: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.thirdProductSku ?? '') + " ", 1),
            (row?.amazonFnsku)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (" + _toDisplayString(row.amazonFnsku) + ") ", 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          deliveryNums: _withCtx(({ row, rowIndex }) => [
            (rowIndex > -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_component_el_form_item, {
                    style: {"margin-right":"0","margin-bottom":"30px"},
                    prop: 'replenishPlanItemList.' + rowIndex + '.deliveryNums',
                    rules: _unref(rules).replenishPlanItemList.deliveryNums(_unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: row.deliveryNums,
                        "onUpdate:modelValue": ($event: any) => ((row.deliveryNums) = $event),
                        max: _unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable,
                        size: "small",
                        onInput: ($event: any) => (_unref(inputPrice)(row)),
                        onChange: ($event: any) => {_unref(changePrice)(row, _unref(form).allIncludeFlag); estimateIntShip.value = null}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput", "onChange"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]))
              : _createCommentVNode("", true)
          ]),
          handler: _withCtx(({ scope }) => [
            _createVNode(_component_table_button, {
              title: _unref(t)('移除'),
              onClick: ($event: any) => {_unref(delRow)(scope.row.productSku); estimateIntShip.value = null}
            }, null, 8, ["title", "onClick"]),
            (scope.row.amazonBindStatus != 2 && !_unref(isCrossMall))
              ? (_openBlock(), _createBlock(_component_table_button, {
                  key: 0,
                  title: _unref(t)('绑定Amazon sku'),
                  onClick: ($event: any) => (openBindAmazon(scope.row))
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          errorResult: _withCtx(({ row }) => [
            (row.errorCode > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('失败')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, "（" + _toDisplayString(_unref(errorMap)[row.errorCode]) + "）", 1)
                ]))
              : _createCommentVNode("", true),
            (row.errorCode === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('成功')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          prepCategory: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(prepCategoryList.value.find(v => v.value === row.prepCategory)?.descJa ?? '-'), 1)
          ]),
          prepOwnerConstraint: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(labelMap)[row.prepOwnerConstraint] ?? '-'), 1)
          ]),
          labelOwnerConstraint: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(labelMap)[row.labelOwnerConstraint] ?? '-'), 1)
          ]),
          useableHead: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(form).allIncludeFlag === 1 ? _unref(t)('一口价商品良品数') : _unref(t)('库存数量')), 1)
          ]),
          useable: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(form).allIncludeFlag === 1 ? row.allIncludeUseable : row.useable), 1)
          ]),
          _: 1
        }, 8, ["table-data", "columns", "table-config", "onSelectionChange"])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(AddProduct, {
      visible: _unref(addProductVisible),
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_isRef(addProductVisible) ? (addProductVisible).value = $event : null)),
      "add-list": _unref(form).replenishPlanItemList,
      type: 2,
      onGetList: _unref(getProductSkuList),
      countryCode: wareType.value,
      allIncludeFlag: _unref(form).allIncludeFlag
    }, null, 8, ["visible", "add-list", "onGetList", "countryCode", "allIncludeFlag"]),
    _createVNode(AddressConfig, {
      visible: _unref(clearanceAddressConfig).visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_unref(clearanceAddressConfig).visible) = $event)),
      config: _unref(clearanceAddressConfig),
      addApi: _unref(addClearance),
      setDefaultApi: _unref(setDefaultClearanceAddress),
      selectAddress: _unref(selectClearanceAddress),
      provinces: _unref(provinces),
      onRefresh: _unref(refreshClearanceList),
      onSelect: _unref(selectClearanceAddressFn),
      warehouseCode: warehouseCode.value,
      wareType: wareType.value
    }, null, 8, ["visible", "config", "addApi", "setDefaultApi", "selectAddress", "provinces", "onRefresh", "onSelect", "warehouseCode", "wareType"]),
    _createVNode(_component_el_dialog, {
      modelValue: templateVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((templateVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", { innerHTML: _unref(templatePreview) }, null, 8, _hoisted_40)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: confirmVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((confirmVisible).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      "custom-class": "create-replenishment-confirm-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_el_icon, { class: "icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(WarningFilled))
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('提示3')), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", {
            style: {"line-height":"1.3"},
            innerHTML: _unref(t)('货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败')
          }, null, 8, _hoisted_43),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: beforeCheckGoods
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AmazonWarningDialog, {
      visible: amazonWarningVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((amazonWarningVisible).value = $event)),
      info: amazonErrorList.value
    }, null, 8, ["visible", "info"]),
    _createVNode(BindAmazonSkuModal, {
      visible: bindAmazonVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((bindAmazonVisible).value = $event)),
      item: rowItem.value,
      onSuccess: setAmazonInfo
    }, null, 8, ["visible", "item"]),
    _createVNode(CheckAmazonGoodsModal, {
      list: _unref(form).replenishPlanItemList,
      ref: (_value, _refs) => {
        _refs['checkAmazonGoodsModalRef'] = _value
        checkAmazonGoodsModalRef.value = _value
      },
      submit: createReplenishment,
      onUpdate: updateGoods,
      onDel: delGoods,
      prepCategoryList: prepCategoryList.value
    }, null, 8, ["list", "prepCategoryList"])
  ]))
}
}

})